import script from "./CobranzaOverdueBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./CobranzaOverdueBoard.vue?vue&type=script&setup=true&lang=js"

import "./CobranzaOverdueBoard.vue?vue&type=style&index=0&id=43dca839&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43dca839"]])

export default __exports__